import $ from 'jquery';

// Create the defaults once
var helper = 'popOver';
var helperClass = 'popover-container';
var defaults = {
    placement: 'left',
    width: 'auto',
    height: 'auto',
    template: '.' + helperClass,
    parentEl: $('body'),
    closeable: false
};
var initialHtml = $('.' + helperClass).html();

export default function PopOver($element, options) {
    this.$element = $element;
    this.options = $.extend({}, defaults, options);
    this.$el = this.options.parentEl;
    this._uniqueId = +new Date();
}

PopOver.prototype = {

    hide: function () {
        if (this.$target) {
            this.$target.removeClass('in').hide();
        }
        if (initialHtml && initialHtml !== '') {
            this.$el.find('.' + helperClass).html(initialHtml);
        }
    },

    show: function () {
        var $target = this.getTarget().addClass(helperClass);

        $target.show();
        this.displayContent();
    },

    displayContent: function () {
        var elementPos = this.getElementPosition();
        var $target = this.getTarget().addClass(helperClass);
        var targetWidth;
        var targetHeight;
        var placement;

        $target.detach().css({
            top: -1999,
            left: -1999,
            display: 'block'
        });

        $target.appendTo(this.$el);
        targetWidth = $target[0].offsetWidth;
        targetHeight = $target[0].offsetHeight;
        placement = this.getPlacement(elementPos);

        var postionInfo = this.getTargetPosition(elementPos, placement, targetWidth, targetHeight);

        this.$target.css(postionInfo.position).addClass(placement).addClass('in');

        var $arrow = this.$target.find('.arrow');

        $arrow.removeAttr('style');
    },

    getTriggerElement: function () {
        return this.$element;
    },

    getTarget: function () {
        if (!this.$target) {
            var id = helper + this._uniqueId;

            this.$target = this.$el.find(this.options.template)
                .attr('id', id)
                .data('trigger-element', this.getTriggerElement());
            this.getTriggerElement().attr('data-target', id);
        }

        return this.$target;
    },

    getPlacement: function () {
        var placement = this.$element.data('placement') || this.options.placement;

        return placement;
    },

    getElementPosition: function () {
        return $.extend({}, this.$element.offset(), {
            width: this.$element[0].offsetWidth,
            height: this.$element[0].offsetHeight
        });
    },

    getTargetPosition: function (elementPos, placement, targetWidth, targetHeight) {
        var pos = elementPos;
        var position = {};

        switch (placement) {
            case 'bottom':
                position = {
                    top: pos.top + pos.height,
                    left: pos.left + pos.width / 2 - targetWidth / 2
                };
                break;
            case 'top':
                position = {
                    top: pos.top - targetHeight,
                    left: pos.left + pos.width / 2 - targetWidth / 2
                };
                break;
            case 'right':
                position = {
                    top: pos.top + pos.height / 2 - targetHeight / 2,
                    left: pos.left + pos.width
                };
                break;

            case 'left':
            default:
                position = {
                    top: pos.top - 15,
                    left: pos.left - targetWidth
                };
                break;
        }

        return {
            position: position
        };
    }

};



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/helpers/addressCheck/addressCheckPopOverView.js
 **/